import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, Navigate, RouterProvider } from "react-router";
import { useLogin, isLoggedIn, login } from "./authConfig";

import "./index.css";

import Layout from "./pages/layout/Layout";
import Chat from "./pages/chat/Chat";
import Admin from "./pages/admin/Admin";
import Info from "./pages/info/Info";
import LandingPage from "./pages/landingPage/LandingPage";
import { ProtectedRoute } from "./components/ProtectedRoute/ProtectedRoute";
import { IT_ROLE, ALL_VALID_ROLES } from "./constants";
import NoAccess from "./pages/noAccess/NoAccess";

const router = createHashRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: "/unauthorized",
                element: <NoAccess />
            },
            {
                // SITSRS-4619: Restrict admin dashboard to IT role only, redirect to homepage
                element: <ProtectedRoute roles={[IT_ROLE]} redirectPath="/" />,
                children: [
                    {
                        path: "admin",
                        element: <Admin />
                    }
                ]
            },
            {
                element: <ProtectedRoute roles={ALL_VALID_ROLES} redirectPath="/unauthorized" />,

                children: [
                    {
                        path: "chat",
                        element: <Chat />
                    },
                    {
                        path: "/",
                        index: true,
                        element: <LandingPage />
                    },
                    {
                        path: "info",
                        element: <Info />
                    }
                ]
            },

            {
                path: "*",
                element: <Navigate to="/" />
            }
        ]
    }
]);

// BFF: when login is enabled and there is no active session cookie, redirect to
// the backend login endpoint (server-side Authorization Code exchange). The
// /auth/me bootstrap in authConfig has already resolved the session by this point.
const AppRoot = () => {
    if (useLogin && !isLoggedIn()) {
        login();
        return <div className="App">Signing in...</div>;
    }
    return <RouterProvider router={router} />;
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <AppRoot />
    </React.StrictMode>
);
